import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useEffect } from 'react';
import InputImg from '../../../../data/inputImg';
import { ISelfServiceProduct } from '../../../../../redux/features/selfService/interface';
import { notifyError } from '../../../../notify/notify-component';
import { useUpdateData } from '../../../../../apiQuery/useUpdateData';
import Globals from '../../../../../Globals.json';

interface IProps {
  show: boolean;
  handleClose: () => void;
  selectedProduct: ISelfServiceProduct | undefined;
  logo: any;
  setLogo: any;
  currentPage: number;
  filter: string;
  storeMe: any;
  updateProduct: any;
}

export function ModalAPP({
  show,
  handleClose,
  selectedProduct,
  logo,
  setLogo,
  storeMe,
  updateProduct,
}: IProps) {
  const handleChangeImg = async () => {
    try {
      await updateProduct({
        endpoint: Globals.api.products,
        id: selectedProduct?.uuid ?? '',
        payload: {
          image: logo,
          id_pdv_category: selectedProduct?.id_pdv_category,
          id_number: 7,
        },
      });

      handleClose();
    } catch (error) {
      //notifyError('Erro ao atualizar imagem');
      console.error(error);
    }
  };

  useEffect(() => {
    setLogo(selectedProduct?.image);
  }, [selectedProduct?.image, setLogo]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Alterar Imagem</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <InputImg state={logo} setState={setLogo} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} type="button">
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleChangeImg} type="button">
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
